import React, { createContext, useContext, useState } from "react"
import { NavigationStep } from "../models/NavigationStep"

interface NavigationContextProps {
  currentStep: NavigationStep
  goToNextStep: () => void
  goToPreviousStep: () => void
  goToStep: (step: NavigationStep) => void
  restart: () => void
}

const steps: NavigationStep[] = [
  NavigationStep.AssetType,
  NavigationStep.Shipments,
  NavigationStep.BusinessExpense,
  NavigationStep.BusinessImprovement,
  NavigationStep.Results,
]

const NavigationContext = createContext<NavigationContextProps | undefined>(
  undefined,
)

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentStep, setCurrentStep] = useState<NavigationStep>(
    NavigationStep.AssetType,
  )

  const goToNextStep = () => {
    const currentIndex = steps.indexOf(currentStep)
    if (currentIndex < steps.length - 1) {
      setCurrentStep(steps[currentIndex + 1])
    }
  }

  const goToPreviousStep = () => {
    const currentIndex = steps.indexOf(currentStep)
    if (currentIndex > 0) {
      setCurrentStep(steps[currentIndex - 1])
    }
  }

  const goToStep = (step: NavigationStep) => {
    if (steps.includes(step)) {
      setCurrentStep(step)
    }
  }

  const restart = () => {
    setCurrentStep(NavigationStep.AssetType)
  }

  return (
    <NavigationContext.Provider
      value={{ currentStep, goToNextStep, goToPreviousStep, goToStep, restart }}
    >
      {children}
    </NavigationContext.Provider>
  )
}

export const useNavigation = () => {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider")
  }
  return context
}
